import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showdashdollar',
})
export class ShowdashdollarPipe extends DecimalPipe {
  transform(value: number): any {
    if (isNaN(value) === false && value !== 0) {
      return `$${super.transform(value)}`;

      // console.log('here');
      // return value;// + '%';
    }
    // console.log('there',value);
    return '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/showdashdollar.pipe.ts